import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { useActions } from 'hooks/useActions';
import { useAppContext } from 'hooks/useContext';
import { executorDecompress } from 'functions/executorDecompress';
import * as actions from './actions';
import { Container, Wrapper } from 'components/Layout/Layout';
import CommunityComments from 'components/CommunityComments/CommunityComments';
import { RankList } from 'components/RankList/RankList';
import CommunityPageImageAndDescription from 'components/CommunityPageImageAndDescription/CommunityPageImageAndDescription';
import {
  ContentContainer,
  ChallengeLabel,
  SectionContainer,
  RankListContainer,
  RankingExplanationText,
} from './styles';

const EXERCISES = 'exercises';
const CHALLENGES = 'challenges';

function decompressPlayback(gamePlay) {
  if (!gamePlay) return gamePlay;
  try {
    return gamePlay.map((match) => {
      return {
        participants: match.participants,
        levels: executorDecompress(match),
        finishedAt: match.finishedAt,
      };
    });
  } catch (e) {
    console.log('Error on decompressing match data: ', e);
  }
}

export default function CommunitySelectedPage() {
  const { pathname } = useLocation();
  const type = pathname.split('/')[1];

  const { id } = useParams();

  const { error, selectedItem, tournamentPlaybacks } = useSelector((state) => state.CommunitySelectedPageReducer);

  const { getExercise, setExerciseRating, getChallenge, setChallengeRating, getTournamentPlayback, resetState } =
    useActions(actions);

  const { isDarkMode } = useAppContext();

  const [pixiLoadingStatus, setPixiLoadingStatus] = useState(false);

  useEffect(() => {
    if (id) {
      if (type === EXERCISES) getExercise(id);
      if (type === CHALLENGES) getChallenge(id);
    }
  }, [id, type, getExercise, getChallenge]);

  useEffect(() => {
    if (error) toast.error(error);
  }, [error]);

  useEffect(() => {
    setPixiLoadingStatus(false);
  }, [tournamentPlaybacks, selectedItem]);

  useEffect(() => {
    return () => {
      if (type === CHALLENGES) resetState();
    };
  }, [type, resetState]);

  const onSelectedRow = (row) => {
    setPixiLoadingStatus(true);
    getTournamentPlayback(id, row.accountId);
  };

  const setItemRating = (challengeRating) => {
    if (type === EXERCISES) setExerciseRating(challengeRating, id);
    if (type === CHALLENGES) setChallengeRating(challengeRating, selectedItem.test);
  };

  const renderTopList = () =>
    !!selectedItem?.rankList?.length && (
      <Container column>
        <ChallengeLabel>Rank List</ChallengeLabel>
        {selectedItem.isTournament && <RankingExplanationText>The ratings are updated nightly</RankingExplanationText>}
        <ContentContainer center>
          <RankListContainer>
            <RankList
              key={selectedItem._id}
              contestId={selectedItem._id}
              onSelectedRow={onSelectedRow}
              isTournament={selectedItem.isTournament}
              rankList={selectedItem.rankList}
              gamePlay={tournamentPlaybacks && decompressPlayback(tournamentPlaybacks)}
              tournamentDetails={selectedItem.tournamentConfig}
              pixiLoadingStatus={pixiLoadingStatus}
              isOfficialChallenge={selectedItem.keywords ? selectedItem.keywords.includes('Official') : false}
              isDarkMode={isDarkMode}
            />
          </RankListContainer>
        </ContentContainer>
      </Container>
    );

  return (
    <Wrapper isNewPage>
      <CommunityPageImageAndDescription
        selectedItem={selectedItem}
        setItemRating={setItemRating}
        startUrl={type === EXERCISES ? `/exercise/${id}` : `/challenge/${id}`}
      />
      {type === CHALLENGES && renderTopList()}

      <Container column>
        <ContentContainer>
          <SectionContainer>
            <ChallengeLabel>Discussion</ChallengeLabel>
            <CommunityComments
              testId={type === CHALLENGES ? selectedItem.test : id}
              contestId={type === CHALLENGES ? id : undefined}
              isDarkMode={isDarkMode}
            />
          </SectionContainer>
        </ContentContainer>
      </Container>
    </Wrapper>
  );
}
